import storage from 'good-storage';
import {APP_NAME} from "../config";

export class Cache {
  constructor(session = false) {
    this.key = APP_NAME;
    if (session) this.cache = storage.session;
    else this.cache = storage;
  }

  get() {
    return this.cache.get(this.key, null);
  }

  set(data) {
    this.cache.set(this.key, data)
  }

  remove() {
    this.cache.remove(this.key)
  }

}
